import React, {ReactElement} from 'react';

import {StoreProvider} from './store';

const RootProvider = ({element}: {element: ReactElement}) => {
  return <StoreProvider>{element}</StoreProvider>;
};

export default RootProvider;
